import {deep_copy} from "../../../lib/js-utils";
import superagent from "superagent";
import {authorize} from "../../helper/authorize-token";
import {APP_IS_LOADING} from "../../app/actions";


const ADMIN_DASHBOARD_LOADING = "ADMIN_DASHBOARD_LOADING";
const ADMIN_DASHBOARD_ALL_USERS = "ADMIN_DASHBOARD_ALL_USERS";
const ADMIN_UPDATE_MATURITY_DATE = "ADMIN_UPDATE_MATURITY_DATE";
const ADMIN_UPDATE_RISK = "ADMIN_UPDATE_RISK";

const LoadAllUsers = (wlf_id, parent_component, component) => {
  return (dispatch, getState) => {
    dispatch({
      type: ADMIN_DASHBOARD_LOADING,
      loading: true,
    });
    dispatch({
      type: APP_IS_LOADING,
      isLoading: true,
    });
    superagent.agent()
      .get("/api/dashboard/user")
      .query({ wlf_id })
      .use(authorize(getState()))
      .then(res => {
        const data = res.body.data;
        const wlfs = component.calcDerivedState(data.wlfs);
        if (data.wlfs.length > 0) {
          component.initSelectedItems(data.wlfs[0].items);
        }
        parent_component.setState({ timestamp_sec: data.timestamp_sec });
        dispatch({
          type: APP_IS_LOADING,
          isLoading: false,
        });
        dispatch({
          type: ADMIN_DASHBOARD_ALL_USERS,
          wlf: wlfs[0],
        })
      })
  }
}

const DEFAULT_STATE = {
  loading: false,
  wlf: {},
}

const updateMaturityDate = (maturityDate, wlfId, itemIndex) => ({
    type: ADMIN_UPDATE_MATURITY_DATE,
    payload: { maturityDate, wlfId, itemIndex }
})

const updateRisk = (risk, wlfId, itemIndex) => ({
    type: ADMIN_UPDATE_RISK,
    payload: { risk, wlfId, itemIndex }
});

const adminUserDashboardReducer = (state = DEFAULT_STATE, action) => {
  let new_state = deep_copy(state);

  switch(action.type) {

    case ADMIN_DASHBOARD_LOADING: {
      new_state.loading = action.loading;
      return new_state;
    }
    case ADMIN_DASHBOARD_ALL_USERS: {
      const item = action.wlf;
      if (item) {
        const wlf_id = item.wlf.id;
        new_state.wlf[wlf_id] = item;
      }
      return new_state;
    }
    case ADMIN_UPDATE_MATURITY_DATE: {
        const { maturityDate, wlfId, itemIndex } = action.payload;
        new_state.wlf[wlfId].items[itemIndex].acct.end_date = maturityDate;

        return new_state;
    }
    case ADMIN_UPDATE_RISK: {
        const { risk, wlfId, itemIndex } = action.payload;
        new_state.wlf[wlfId].items[itemIndex].risk = risk;

        return new_state
    }
    default:
      return new_state;
  }

}

export { adminUserDashboardReducer, LoadAllUsers, updateMaturityDate, updateRisk };

